<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "pipeline-wrapper"
};
</script>

<style>
</style>